import React, { Component } from "react";

class Image extends Component {
  title = '';
  url = '#';

  render() {
    return(
      <img src={this.props.url} title={this.props.title} alt={this.props.title} />
    )
  }
}

export default Image
